import React from 'react';
import DataResource from '../../../common/v4/DataResource'
import Panel from '../../../common/layout/Panel'

export default class extends React.Component {
    render () {
        const data = {
            url: `/admin/users`,
            data: {
                data: [],
                metadata: []
            },
            onclick: 'link',
            link: `/admin/users/{id}`,
            metadata: [
                {
                    label: 'id',
                    source: 'id',
                    type: 'primary',
                    editable: false,
                    visible: false
                },
                {
                    label: 'Email',
                    source: 'email',
                    type: 'email',
                    editable: true,
                    default: '',
                    placeholder: 'username'
                },
                {
                    label: 'Name',
                    source: 'name',
                    type: 'text'
                },
                {
                    label: 'Phone',
                    source: 'phone',
                    type: 'text',
                },
                {
                    label: 'Timezone',
                    source: 'timezone',
                    type: 'text',
                },
                {
                    label: 'Access Groups',
                    source: 'access_group_names',
                    type: 'text',
                },
                {
                    label: 'Enabled',
                    source: 'enabled',
                    type: 'boolean',
                },
                {
                    label: 'Email Verified At',
                    source: 'email_verified_at',
                    type: 'datetime',
                },
                {
                    label: 'WebRTC',
                    source: 'webrtc_enable',
                    type: 'boolean',
                },
                {
                    label: 'Created At',
                    source: 'created_at',
                    type: 'datetime',
                },
                {
                    label: 'Updated At',
                    source: 'updated_at',
                    type: 'datetime',
                },
                {
                    label: 'Delete',
                    type: 'delete',
                }
            ]
        }
        return (
            <Panel title = "Admin Accounts">
                <DataResource
                    addButtonText = "Add Admin Account"   
                    addButtonLink = "/admin/users/create"                 
                    data = {data}
                    {...this.props} 
                />
            </Panel>
        )
    }
}